import { useBooleanFlagValue } from '@openfeature/react-sdk';

export const useApprovalDrawerViewOptimizationFlag = (): boolean =>
  useBooleanFlagValue('approval-drawer-view-optimization', false);
